// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 535 ? "login" : chunkId) + "." + {"53":"72398fd0","535":"8007898a"}[chunkId] + ".css";
};